import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Search = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.2918 29.1669H30.6456L30.0624 28.6044C32.347 25.9427 33.5115 22.4994 33.3114 18.9974C33.1113 15.4955 31.5623 12.2072 28.9894 9.82307C26.4165 7.43891 23.02 6.14429 19.513 6.21101C16.006 6.27774 12.6612 7.70062 10.1809 10.1809C7.70056 12.6612 6.27768 16.006 6.21095 19.5131C6.14423 23.0201 7.43885 26.4166 9.82301 28.9895C12.2072 31.5623 15.4954 33.1114 18.9974 33.3115C22.4993 33.5116 25.9426 32.3471 28.6043 30.0625L29.1668 30.6456V32.2913L39.5831 42.6875L42.6874 39.5831L32.2918 29.1669ZM19.7918 29.1669C17.9376 29.1669 16.1251 28.617 14.5833 27.5869C13.0416 26.5568 11.84 25.0926 11.1304 23.3795C10.4209 21.6665 10.2352 19.7815 10.597 17.9629C10.9587 16.1443 11.8516 14.4739 13.1627 13.1628C14.4738 11.8516 16.1443 10.9588 17.9628 10.597C19.7814 10.2353 21.6664 10.4209 23.3795 11.1305C25.0925 11.8401 26.5567 13.0417 27.5868 14.5834C28.617 16.1251 29.1668 17.9377 29.1668 19.7919C29.1685 21.0235 28.9271 22.2433 28.4565 23.3815C27.986 24.5197 27.2955 25.5538 26.4246 26.4247C25.5537 27.2956 24.5196 27.986 23.3814 28.4566C22.2432 28.9272 21.0234 29.1685 19.7918 29.1669Z"
        fill={color}
      />
    </svg>
  )
}
